// extracted by mini-css-extract-plugin
export default {"link":"g0xxPE5LpIBSv9eeLejA","description":"NXy4XKtFBEuohjppRC6r","pulse":"Hp2GgQEiBEzb_PoO3hpw"};